<template>
  <div class="memory-dot" :style="{ backgroundColor: color }" />
</template>

<script setup lang="ts">
defineProps<{
  color: string;
}>();
</script>

<style scoped>
.memory-dot {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 50%;
  background: radial-gradient(
    circle at 30% 30%,
    rgba(255, 255, 255, 0.4) 0%,
    transparent 50%
  );
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.3),
    inset 0 -2px 4px rgba(255, 255, 255, 0.4), 0 4px 8px rgba(0, 0, 0, 0.4),
    0 2px 4px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1);
  transition: all 0.2s ease;
  position: relative;
  overflow: visible;
}
.memory-dot::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 50%;
  background: radial-gradient(
    circle at 70% 70%,
    rgba(0, 0, 0, 0.2) 0%,
    transparent 50%
  );
  pointer-events: none;
  z-index: 1;
}
</style>
